import { render, staticRenderFns } from "./new_datail.vue?vue&type=template&id=94be8d52&scoped=true&"
import script from "./new_datail.vue?vue&type=script&lang=js&"
export * from "./new_datail.vue?vue&type=script&lang=js&"
import style0 from "./new_datail.vue?vue&type=style&index=0&id=94be8d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94be8d52",
  null
  
)

export default component.exports